import { initialState } from '../state';
import { TreatmentSelectionActions, TreatmentSelectionActionsTypes } from '../actions/treatment-selection.actions';

export function selectedTreatmentNodeId(state = initialState.selectedTreatmentNodeId, action: TreatmentSelectionActions): string {
  switch (action.type) {
    case TreatmentSelectionActionsTypes.UPDATE_SELECTED_TREATMENT:
      return action.payload.selectedTreatmentActivityId;
    default:
      return state;
  }
}
